// Utility function to format money similar to Shopify's money filter
function formatMoney(cents, currency = 'AUD') {
  // Convert cents to dollars
  const dollars = cents / 100;

  // Format with proper currency formatting
  return new Intl.NumberFormat('en-AU', {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(dollars);
}

class ByrWrapper extends HTMLElement {
  constructor() {
    super();
    this.tabsHeader = this.querySelector('.byr-header');
    this.tabs = this.querySelectorAll('.byr-header__tab');
    this.tabsHeaderContent = this.querySelectorAll('.byr-header__active-tab-content');
    this.tabsContent = this.querySelectorAll('.byr-grid-items');

    const isProductAdded = localStorage.getItem('byr-products-added');
    if (isProductAdded) {
      // If products were added, we can remove the flag
      localStorage.removeItem('byr-products');
      localStorage.removeItem('byr-products-added');
    }
  }

  connectedCallback() {
    this.tabs.forEach(tab => {
      tab.addEventListener('click', this.handleTabClick.bind(this));
    });

    document.addEventListener('byr:product:added', (event) => {
      const stepTitle = event.detail.productStep;

      this.tabs.forEach(tab => {
        const tabText = tab.getAttribute('data-product-step');
        if (tabText === stepTitle) {
          tab.classList.add('byr-header__tab--selected');
        }
      });
    });

    document.addEventListener('byr:product:rendered', (event) => {
      const stepTitle = event.detail.productStep;

      this.tabs.forEach(tab => {
        const tabText = tab.getAttribute('data-product-step');
        if (tabText === stepTitle) {
          tab.classList.add('byr-header__tab--selected');
        }
      });
    });

    document.addEventListener('byr:product:removeRendered', (event) => {
      const stepTitle = event.detail.productStep;

      this.tabs.forEach(tab => {
        const tabText = tab.getAttribute('data-product-step');
        if (tabText === stepTitle) {
          tab.classList.remove('byr-header__tab--selected');
        }
      });
    });
  }

  handleTabClick(event) {
    event.preventDefault();
    const tab = event.currentTarget;
    const tabIndex = Array.from(this.tabs).indexOf(tab);

    this.tabs.forEach(tab => tab.classList.remove('byr-header__tab--active'));
    tab.classList.add('byr-header__tab--active');

    this.tabsHeaderContent.forEach(content => content.classList.remove('byr-header__active-tab-content--active'));
    this.tabsHeaderContent[tabIndex].classList.add('byr-header__active-tab-content--active');

    this.tabsContent.forEach(content => content.classList.remove('byr-grid-items--active'));
    this.tabsContent[tabIndex].classList.add('byr-grid-items--active');
  }

  viewTabStep(stepTitle) {
    this.tabs.forEach(tab => tab.classList.remove('byr-header__tab--active'));
    this.querySelector(`.byr-header__tab[data-product-step="${stepTitle}"]`).classList.add('byr-header__tab--active');

    this.tabsHeaderContent.forEach(content => content.classList.remove('byr-header__active-tab-content--active'));
    this.querySelector(`.byr-header__active-tab-content[data-product-step="${stepTitle}"]`).classList.add('byr-header__active-tab-content--active');

    this.tabsContent.forEach(content => content.classList.remove('byr-grid-items--active'));
    this.querySelector(`.byr-grid-items[data-product-step="${stepTitle}"]`).classList.add('byr-grid-items--active');

    this.tabsHeader.scrollIntoView({ behavior: 'smooth', block: 'end' });
  }
}

customElements.define('byr-wrapper', ByrWrapper);

class ByrProductCard extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.submitButton = this.form.querySelector('.byr-product-card__action-button');
    this.productStep = this.getAttribute('data-product-step');
    this.productId = parseInt(this.getAttribute('data-product-id'));
    this.nextStep = this.getAttribute('data-next-step');
    this.byrWrapper = this.closest('byr-wrapper');
    this.descriptionToggle = this.querySelector('.byr-product-card__description-toggle');
    this.description = this.querySelector('.byr-product-card__description');

    this.form.addEventListener('submit', this.handleSubmit.bind(this));
  }

  connectedCallback() {
    this.validateProductAdded();
    document.addEventListener('byr:product:added', this.validateProductAdded.bind(this));
    // document.addEventListener('byr:bundle:added', () => {
    //   this.submitButton.disabled = true;
    // })
    this.descriptionToggle.addEventListener('click', this.toggleDescription.bind(this));
  }

  validateProductAdded(event) {
    let variantId = null;
    let productId = null;
    let productStep = null;
    if (event) {
      variantId = event.detail.variantId;
      productId = event.detail.productId;
      productStep = event.detail.productStep;
    }
    if (variantId === null || productId === null || productStep === null) {
      const productAdded = localStorage.getItem('byr-products');
      if (productAdded) {
        const products = JSON.parse(productAdded);
        const product = products.find(product => product.step === this.productStep);
        if (product) {
          variantId = product.variantId;
          productId = product.productId;
          productStep = product.step;
        }
      }
    }

    if (this.productStep === 'Addons') {
      const productsAdded = localStorage.getItem('byr-products');
      if (productsAdded) {
        const productsObj = JSON.parse(productsAdded);
        const products = productsObj.filter(product => product.step === this.productStep && product.productId === this.productId);
        if (products.length > 0) {
          products.forEach(product => {
            if (product.productId === this.productId) {
              this.submitButton.classList.add('byr-product-card__action-button--added');
              this.submitButton.textContent = 'Added to routine';
            }
          });
        } else {
          if (this.submitButton.textContent === 'Out of stock') return;
          this.submitButton.classList.remove('byr-product-card__action-button--added');
          this.submitButton.textContent = 'Add to routine';
        }
      }
    } else if (productStep === this.productStep) {
      if (productId === this.productId) {
        this.submitButton.classList.add('byr-product-card__action-button--added');
        this.submitButton.textContent = 'Added to routine';
      } else {
        if (this.submitButton.textContent.trim() === 'Out of stock') return;
        this.submitButton.classList.remove('byr-product-card__action-button--added');
        this.submitButton.textContent = 'Add to routine';
      }
    }
  }

  handleSubmit(event) {
    event.preventDefault();
    const formData = new FormData(this.form);
    const variantId = formData.get('id');
    const handle = formData.get('handle');
    const price = formData.get('price');

    const data = {
      variantId: variantId,
      step: this.productStep,
      productId: this.productId,
      handle: handle,
      price: price
    };

    let byrProducts = [];
    const currentData = localStorage.getItem('byr-products');

    if (currentData) {
      try {
        byrProducts = JSON.parse(currentData);
        if (!Array.isArray(byrProducts)) {
          byrProducts = [];
        }
      } catch (e) {
        console.error('Error parsing byr-products from localStorage:', e);
        byrProducts = [];
      }
    }

    const existingProductIndex = byrProducts.findIndex(product => product.variantId === variantId);

    if (existingProductIndex !== -1) {
      console.error('product already added');
      return;
    }

    if (this.productStep === 'Addons') {
      byrProducts.push(data);
    } else {
      const existingStepIndex = byrProducts.findIndex(product => product.step === this.productStep);

      if (existingStepIndex !== -1) {
        byrProducts[existingStepIndex] = data;
      } else {
        byrProducts.push(data);
      }
    }

    localStorage.setItem('byr-products', JSON.stringify(byrProducts));

    const customEvent = new CustomEvent('byr:product:added', {
      detail: {
        variantId: variantId,
        productId: this.productId,
        productStep: this.productStep,
        handle: handle,
        price: price,
        allProducts: byrProducts
      },
      bubbles: true,
      composed: true
    });
    this.dispatchEvent(customEvent);

    this.submitButton.textContent = 'Added to routine';
    this.submitButton.classList.add('byr-product-card__action-button--added');



    if (this.nextStep) {
      setTimeout(() => {
        this.byrWrapper.viewTabStep(this.nextStep);
      }, 1000);
    }
  }

  toggleDescription() {
    this.descriptionToggle.classList.toggle('byr-product-card__description-toggle--active');
    this.description.classList.toggle('byr-product-card__description--active');
  }
}

customElements.define('byr-product-card', ByrProductCard);

class BundleVariantSelects extends HTMLElement {
  constructor() {
    super();
    this.productCard = this.closest('byr-product-card');
    this.variantSelectors = this.querySelectorAll('[data-single-option-selector]');
    this.variantIdInput = this.productCard.querySelector('input[name="id"]');
    this.variantPriceInput = this.productCard.querySelector('input[name="price"]');
    this.priceDisplay = this.productCard.querySelector('.byr-product-card__title span');
    this.productJsonScript = this.productCard.querySelector('[data-product-json]');

    if (!this.productJsonScript) return;

    this.product = JSON.parse(this.productJsonScript.textContent);
  }

  connectedCallback() {
    this.variantSelectors.forEach(selector => {
      selector.addEventListener('change', this.updateVariant.bind(this));
    });

    this.updateVariant();
  }

  updateVariant() {
    const selectedOptions = [];

    this.variantSelectors.forEach(selector => {
      if (selector.checked) {
        selectedOptions.push(selector.value);
      }
    });

    // Find matching variant
    const matchingVariant = this.product.variants.find(variant => {
      return variant.options.every((option, index) => {
        return option === selectedOptions[index];
      });
    });

    if (matchingVariant) {
      // Update hidden inputs
      this.variantIdInput.value = matchingVariant.id;
      this.variantPriceInput.value = matchingVariant.price;

      // Update price display
      const formattedPrice = new Intl.NumberFormat('en-AU', {
        style: 'currency',
        currency: 'AUD',
        minimumFractionDigits: 0
      }).format(matchingVariant.price / 100);

      this.priceDisplay.textContent = formattedPrice;

      const addButton = this.productCard.querySelector('.byr-product-card__action-button');
      const localStorageProducts = localStorage.getItem('byr-products');
      let isAdded = false;
      if (localStorageProducts) {
        const products = JSON.parse(localStorageProducts);

        isAdded = products.some(product => product.variantId == matchingVariant.id && product.productId == this.product.id);
      }

      if (isAdded) {
        addButton.classList.add('byr-product-card__action-button--added');
        addButton.textContent = 'Added to routine';
        // addButton.disabled = true;
      } else {
        // if (!addButton.classList.contains('byr-product-card__action-button--added')) {
        if (matchingVariant.available) {
          addButton.classList.remove('byr-product-card__action-button--added');
          addButton.disabled = false;
          addButton.textContent = 'Add to routine';
        } else {
          addButton.classList.remove('byr-product-card__action-button--added');
          addButton.disabled = true;
          addButton.textContent = 'Out of stock';
        }
        // }
      }
    }
  }
}

customElements.define('bundle-variant-selects', BundleVariantSelects);

class ByrProgress extends HTMLElement {
  constructor() {
    super();
    this.stepsCount = this.getAttribute('data-steps-count');
    this.progressBarFill = this.querySelector('.byr-summary__progress-fill');
    this.progressBarText = this.querySelector('.byr-summary__progress-text');
    this.addOnOptional = this.getAttribute('data-add-on-optional') === 'true';
  }

  connectedCallback() {
    this.updateProgress();
    document.addEventListener('byr:product:added', this.updateProgress.bind(this));
  }

  updateProgress(event) {
    let products = null;
    if (event) {
      products = event.detail.allProducts;
    } else {
      const localStorageProducts = localStorage.getItem('byr-products');
      if (localStorageProducts) {
        products = JSON.parse(localStorageProducts);
      }
    }

    if (products) {
      const productsCount = this.addOnOptional ? products.filter(product => product.step !== 'Addons').length : products.length;
      this.progressBarText.textContent = `${productsCount}/${this.stepsCount} Products`;
      this.progressBarFill.style.width = `${Math.min(1, (productsCount / this.stepsCount)) * 100}%`;
    }
  }
}

customElements.define('byr-progress', ByrProgress);

class ByrSummary extends HTMLElement {
  constructor() {
    super();
    this.aside = this.closest('aside');
    this.headerElement = this.querySelector('.byr-summary__content-header');
    this.submitButton = this.querySelector('.byr-summary__cta');
    this.addOnOptional = this.getAttribute('data-add-on-optional') === 'true';
    this.totalPrice = this.querySelector('.byr-sumary-total__price');
    this.comparePrice = this.querySelector('.byr-sumary-total__price-compare');
    this.stepsCount = this.getAttribute('data-steps-count');
    this.successMessage = this.getAttribute('data-success-message');
    this.message = this.getAttribute('data-message');
    this.progressBarMessage = this.querySelector('.byr-summary__progress-message');
    this.cartItems = document.querySelector('cart-items');
    this.itemsWrapper = this.querySelector('.byr-summary__content-body');
    this.headerIcon = this.querySelector('.byr-summary__content-header-icon');
  }

  connectedCallback() {
    this.updateFooter();
    this.addAddonsToCart();
    this.setUpBottomPosition();
    document.addEventListener('byr:product:added', (event) => {
      this.updateFooter(event);
      if (event.detail.productStep === 'Addons') {
        this.addAddonsToCart(event);
      }
    });
    this.submitButton.addEventListener('click', this.handleSubmit.bind(this));
    window.addEventListener('resize', this.setUpBottomPosition.bind(this));
    this.headerElement.addEventListener('click', this.toggleSummary.bind(this));
  }

  updateFooter(event) {
    let products = null;
    if (event) {
      products = event.detail.allProducts;
      this.products = products;
    } else {
      const localStorageProducts = localStorage.getItem('byr-products');
      if (localStorageProducts) {
        products = JSON.parse(localStorageProducts);
        this.products = products;
      }
    }

    if (products) {
      this.submitButton.textContent = `${products.length}/${this.stepsCount} SELECT`;
      this.productsCount = this.addOnOptional ? products.filter(product => product.step !== 'Addons').length : products.length;
      if (this.productsCount >= parseInt(this.stepsCount)) {
        this.submitButton.classList.remove('byr-summary__cta--disabled');
        this.submitButton.removeAttribute('disabled');
        this.progressBarMessage.textContent = this.successMessage;
        this.submitButton.textContent = 'Add to bag';
        if (window.innerWidth < 768) {
          this.toggleSummary();
        }
      } else {
        this.submitButton.classList.add('byr-summary__cta--disabled');
        this.submitButton.setAttribute('disabled', true);
        this.progressBarMessage.textContent = this.message;
        this.submitButton.textContent = `${this.productsCount}/${this.stepsCount} SELECT`;
      }

      this.updateTotalPrice(products);
    }
  }

  updateTotalPrice(products) {
    if (products) {
      const totalPrice = products.reduce((acc, product) => acc + parseFloat(product.price), 0);
      const discountedPrice = totalPrice - (totalPrice * 0.2);
      const formattedPrice = formatMoney(totalPrice);
      const formattedDiscountedPrice = formatMoney(discountedPrice);
      this.totalPrice.textContent = formattedPrice;

      if (this.productsCount === parseInt(this.stepsCount)) {
        this.comparePrice.classList.remove('hidden');
        this.comparePrice.textContent = formattedPrice;
        this.totalPrice.textContent = formattedDiscountedPrice;
      } else {
        this.comparePrice.classList.add('hidden');
        this.comparePrice.textContent = '';
        this.totalPrice.textContent = formattedPrice;
      }
    }
  }

  addAddonsToCart(event) {
    let itemTemplate = addonItemTemplate;
    if (event) {
      itemTemplate = itemTemplate.replace('data-product-step="Addons"', `data-product-step="Addons" data-product-handle="${event.detail.handle}"`);
      this.itemsWrapper.insertAdjacentHTML('beforeend', itemTemplate);
    } else {
      const localStorageProducts = localStorage.getItem('byr-products');
      if (localStorageProducts) {
        const products = JSON.parse(localStorageProducts);
        const addons = products.filter(product => product.step === 'Addons');
        if (addons.length > 0) {
          addons.forEach(addon => {
            itemTemplate = itemTemplate.replace('data-product-step="Addons"', `data-product-step="Addons" data-product-handle="${addon.handle}"`);
            this.itemsWrapper.insertAdjacentHTML('beforeend', itemTemplate);
          });
        }
      }
    }

  }

  handleSubmit(event) {
    event.preventDefault();

    if (!this.products || this.products.length === 0) {
      console.error('No products to add to cart');
      return;
    }

    const bundleId = Math.floor(1000 + Math.random() * 9000).toString();

    // this.submitButton.disabled = true;
    this.submitButton.textContent = 'Adding to bag...';

    const items = this.products.map(product => ({
      id: product.variantId,
      quantity: 1,
      properties: {
        _bundle_id: bundleId,
        _bundle_step: product.step,
      }
    }));

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ items })
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Failed to add items to cart');
        }
        return response.json();
      })
      .then(data => {
        // localStorage.removeItem('byr-products');

        localStorage.setItem('byr-products-added', true);

        const customEvent = new CustomEvent('byr:bundle:added', {
          detail: {
            bundleId: bundleId,
            items: data.items,
            totalPrice: this.totalPrice.textContent
          },
          bubbles: true,
          composed: true
        });
        this.dispatchEvent(customEvent);

        this.submitButton.textContent = 'Add to bag';

        this.cartItems.getCart();
      })
      .catch(error => {
        console.error('Error adding bundle to cart:', error);
        this.submitButton.disabled = false;
        this.submitButton.textContent = 'Error - Try again';

        setTimeout(() => {
          this.submitButton.textContent = 'Add to bag';
        }, 2000);
      });
  }

  setUpBottomPosition() {
    const summaryHeight = this.aside.offsetHeight;
    const headerHeight = this.headerElement.offsetHeight;
    const bottomValue = `${summaryHeight - headerHeight - 24}px`;
    this.aside.style.setProperty('--bottom-mobile', `-${bottomValue}`);
  }

  toggleSummary() {
    this.aside.classList.toggle('byr-summary--active');
    if (!this.aside.classList.contains('byr-summary--active')) {
      this.setUpBottomPosition();
    }
  }
}

customElements.define('byr-summary', ByrSummary);

class ByrSummaryItem extends HTMLElement {
  constructor() {
    super();
    this.byrWrapper = this.closest('byr-wrapper');
    this.productStep = this.getAttribute('data-product-step');
    this.productTitle = this.querySelector('.byr-sumary_item-product');
    this.productImage = this.querySelector('.byr-sumary_item-image img');
    this.productEdit = this.querySelector('.byr-sumary_item-product-edit');
    this.productRemove = this.querySelector('.byr-sumary_item-product-remove');
    this.productHandle = this.getAttribute('data-product-handle');
    this.stepElement = this.querySelector('.byr-sumary_item-wrapper > span');
    this.plusIcon = this.querySelector('.byr-sumary_item-image-icon');
    this.summary = this.closest('byr-summary');
  }

  connectedCallback() {
    if (this.productHandle) {
      this.fetchProduct(this.productHandle);
    } else {
      this.getProduct();
    }
    document.addEventListener('byr:product:added', this.getProduct.bind(this));

    this.productEdit.addEventListener('click', () => {
      this.byrWrapper.viewTabStep(this.productStep);
    });

    this.plusIcon?.addEventListener('click', () => {
      this.byrWrapper.viewTabStep(this.productStep);
    });

    this.stepElement.addEventListener('click', () => {
      this.byrWrapper.viewTabStep(this.productStep);
    });

    if (this.productRemove) {
      this.productRemove.addEventListener('click', () => {
        const localStorageProducts = localStorage.getItem('byr-products');
        if (localStorageProducts) {
          let products = JSON.parse(localStorageProducts);
          products = products.filter(product => !(product.step === this.productStep && product.handle === this.productHandle));
          localStorage.setItem('byr-products', JSON.stringify(products));
          this.removeProduct();
          this.summary.updateFooter();
          this.remove();
          document.querySelectorAll('byr-product-card').forEach(item => {
            item.validateProductAdded();
          })
        }
      });
    }
  }

  getProduct(event) {
    let products = null;
    if (event) {
      products = event.detail.allProducts;
    } else {
      const localStorageProducts = localStorage.getItem('byr-products');
      if (localStorageProducts) {
        products = JSON.parse(localStorageProducts);
      }
    }

    if (products) {
      const productObj = products.find(product => this.productStep == 'Addons' ? (product.step === this.productStep && product.handle === this.productHandle) : product.step === this.productStep);
      if (productObj) {
        const handle = productObj.handle;
        this.fetchProduct(handle);
      }
    }
  }

  fetchProduct(handle) {
    try {
      fetch(`/products/${handle}.json`)
        .then(response => response.json())
        .then(data => {
          const { product } = data;
          this.product = product;
          if (product) {
            this.renderProduct();
          } else {
            this.removeProduct();
          }
          this.summary.setUpBottomPosition();
        })
        .catch(error => {
          console.error('Error fetching product:', error);
        });
    } catch (error) {
      console.error('Error fetching product:', error);
    }
  }

  renderProduct() {
    this.classList.remove('empty');
    this.classList.remove('current-step--no-added');
    this.productTitle.textContent = this.product.title;
    this.productImage.src = this.product.image.src;
    this.productImage.alt = this.product.title;

    document.dispatchEvent(new CustomEvent('byr:product:rendered', {
      detail: {
        productStep: this.productStep,
        productId: this.product.id,
        productTitle: this.product.title,
        productImage: this.product.image.src
      }
    }));
  }

  removeProduct() {
    this.classList.add('empty');
    this.classList.add('current-step--no-added');
    this.productTitle.textContent = '';
    this.productImage.src = '';
    this.productImage.alt = '';

    document.dispatchEvent(new CustomEvent('byr:product:removeRendered', {
      detail: {
        productStep: this.productStep,
        productId: this.product.id,
        productTitle: this.product.title,
        productImage: this.product.image.src
      }
    }));
  }
}

customElements.define('byr-summary-item', ByrSummaryItem);

class ByrTabs extends HTMLElement {
  constructor() {
    super();
    this.wrapper = this.closest('.byr-header__tabs-wrapper');
    this.lastTab = this.querySelector('.byr-header__tab:last-child');
    this.arrowMobile = this.wrapper.querySelector('.byr-header__tabs-gradient-icon');
  }

  connectedCallback() {
    if (this.lastTab) {
      this.setupIntersectionObserver();
    }

    if (window.innerWidth < 768) {
      this.arrowMobile.addEventListener('click', () => {
        // scroll to left 5px each time the arrow is clicked
        this.scrollBy({
          left: 50,
          behavior: 'smooth'
        });
      });
    }
  }

  setupIntersectionObserver() {
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.7
    };

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.7) {
          this.wrapper.classList.add('hide-gradient');
        } else {
          this.wrapper.classList.remove('hide-gradient');
        }
      });
    }, options);

    this.observer.observe(this.lastTab);
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}

customElements.define('byr-tabs', ByrTabs);